import { Component, Input, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { SanitizerPipe } from '../pipe/santizer.pipe';
import { LayoutService } from '../../services/layout.service';

/**
 * Mobile (<768px) primary navigation: Home + the top permission-filtered
 * modules + "More" (opens the drawer). Items come from the same DB-driven
 * menu tree as the sidebar (MenuName / RouterPath / Svg_Default / children).
 */
@Component({
  selector: 'app-bottom-nav',
  standalone: true,
  imports: [CommonModule, MatIconModule, SanitizerPipe],
  templateUrl: './bottom-nav.html',
  styleUrl: './bottom-nav.scss',
})
export class BottomNav {
  @Input() userMenus: any[] = [];

  private router = inject(Router);
  public layout = inject(LayoutService);

  /** First 3 root modules (userMenus is already iOrder-sorted upstream). */
  get quickMenus(): any[] {
    return (this.userMenus || []).slice(0, 3);
  }

  goHome() {
    this.router.navigate(['/home']);
  }

  /** Same semantics as the sidebar: a parent shortcuts to its first child. */
  go(menu: any) {
    const target = menu.children?.length
      ? menu.children[0].RouterPath
      : menu.RouterPath;
    if (target) {
      this.router.navigate([target]);
    }
  }

  isHomeActive(): boolean {
    return this.router.url.split('?')[0] === '/home';
  }

  isMenuActive(menu: any): boolean {
    const current = this.router.url.split('?')[0];
    const normalize = (p: string) => (p?.startsWith('/') ? p : '/' + p);
    const paths = menu.children?.length
      ? menu.children.map((c: any) => c.RouterPath)
      : [menu.RouterPath];
    return paths.filter(Boolean).some((p: string) => {
      const target = normalize(p);
      return current === target || current.startsWith(target + '/');
    });
  }
}
